// Tests: src/app/migrations/migrations.spec.ts
import { MigrationDefinition } from './migration.types';

/**
 * Migration: V14 → V15
 *
 * Grubenprotokoll (SEA 95, Darst. B 3-6) — zwei zusaetzliche Schichtfelder:
 *  - `substratherkunft`: Freitext (z. B. "glz", "fl", "äol")
 *  - `probeentnahme`: { spanne?, flaeche?, volumen? } — Markierung der
 *     im Profil gezogenen Bodenproben (Spanne in cm, Flaeche/Volumen
 *     der Probe als Eckdaten der Probenahme).
 *
 * Upgrade additiv. Downgrade entfernt die Felder pro Substratzeile.
 */
export const migrationV14ToV15: MigrationDefinition = {
  fromVersion: 14,
  toVersion: 15,

  upgrade(doc: any): any {
    doc.version = 15;
    return doc;
  },

  downgrade(doc: any): any {
    if (Array.isArray(doc.Substratfolge)) {
      for (const row of doc.Substratfolge) {
        if (row && typeof row === 'object') {
          delete row.substratherkunft;
          delete row.probeentnahme;
        }
      }
    }
    doc.version = 14;
    return doc;
  },

  dataLossWarnings: [
    'Beim Downgrade gehen pro Substratzeile substratherkunft und probeentnahme verloren'
  ]
};
